import React, {useEffect} from 'react'
import {Card, CardBody, CardTitle} from "reactstrap";
import {LB_GALLERY, LB_LANG, LB_THUMB, LIST, NO_DATA_FOUND, LB_SAME_IMG_LANGS, LB_ASPECT_RATIO, LB_ORDER_CONFIG, LB_ALLOWED_FORMATS, LB_LABEL} from "../../../components/i18n/i18n";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

// components
import FbMediaConfigForm from "./_form";
import FbMediaConfigFilter from "./_filter";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";

// labels
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import {fbMediaConfigService} from "../../../jwt/_services/configuration/fbMediaConfigService";

// actions
import {genericActions} from "../../../redux/actions/generics/GenericActions";
import {setFilter, setTableParams} from "../../../redux/actions/generalActions/listActions";
import {setMapConfig} from "../../../redux/actions/generalActions/mainActions";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {connect} from "react-redux";
import {FL_CLASS_NAME, FL_CODE, FL_DATA_BASE} from "../../../components/i18n/formLabels";
import {ActiveFormatter} from "../../../components/tables/activeFormater";


const FbMediaConfigList = props => {
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps
    const { app, udn } = props.mainProps

    useEffect(()=>{
        if(filter)
            return

        props.setFilter( {
            item : {
                className   : null,
                fieldCode   : null,
            },
        } )
    }, [ app, udn ]);



    useEffect(() => {
        if(!filter)
            return

        genericActions.search(fbMediaConfigService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);




    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };



    const confirmDelete = (data) => ConfirmDelete({
            remove : genericActions.remove ,
            data : data,
            fbDataBaseId :  app?.fbDataBase?.id,
            service: fbMediaConfigService
        } );

    const editItem = (data) => {
        props.setForm(true, false, false);
        props.setItem(data);
        ModalFormContainer(FbMediaConfigForm, {data, Form:FbMediaConfigForm})
    }


    const columns = [
        {
            dataField: 'id',
            headerStyle: {width: '0px'},
            text: 'ID',
            hidden: true
        },
        {
            dataField: 'className',
            text: `${FL_CLASS_NAME}`,
            headerStyle: {width: '200px'}
        }, {
            dataField: 'fieldCode',
            text: 'Campo',
        }, 
        {
            dataField: 'fbMediaLabel',
            text: `${LB_LABEL}`,
        },
        {
            dataField: 'fbDataBase',
            text: `${FL_DATA_BASE}`,
            headerStyle: {width: '150px'},
            formatter: (cell, row) => row.fbDataBase?.code
        },
        {
            dataField: 'path',
            text: 'Url'
        },
        {
            dataField: 'useThumb',
            text: `${LB_THUMB}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '50px'},
            formatter: (cell, row) => <ActiveFormatter active={cell}/>
        }, {
            dataField: 'useGallery',
            text: `${LB_GALLERY}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '50px'},
            formatter: (cell, row) => <ActiveFormatter active={cell}/>
        }, {
            dataField: 'use18n',
            text: `${LB_LANG}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '50px'},
            formatter: (cell, row) => <ActiveFormatter active={cell}/>
        }, {
            dataField: 'use18nSameImage',
            text: `${LB_SAME_IMG_LANGS}`,
            headerAlign: 'center',
            align: 'center',    
            headerStyle: {width: '50px'},
            formatter: (cell, row) => <ActiveFormatter active={cell}/>
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: 'Acción',
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '150px'},
            formatter: (cell, row) => <>
                <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
                <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
            </>
        }];


    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>
            {LIST}
        </CardTitle>

        <FbMediaConfigFilter  />

        <CardBody className="">
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={ columns }
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={ handleTableChange }
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
    setMapConfig,
})
export default connect(mapStateToProps, mapActionsToProps)(FbMediaConfigList)